import React, { useState } from 'react';
import { Button, Modal, Form, Input, Radio } from 'antd';

interface Values {
  title: string;
  description: string;
  modifier: string;
}

interface CollectionCreateFormProps {
  visible: boolean;
  onCreate: (values: Values) => void;
  onCancel: () => void;
}

const CollectionCreateForm: React.FC<CollectionCreateFormProps> = ({
  visible,
  onCreate,
  onCancel,
}) => {
  const [form] = Form.useForm();
  return (
    <Modal
      visible={visible}
      title="Ajouter un nouveau client"
      okText="Enregistrer"
      cancelText="annuler"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            form.resetFields();
            onCreate(values);
          })
          .catch(info => {
            console.log('Validate Failed:', info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
      >
        <Form.Item name='nom' label="Nom" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name='prenom' label="Prenom" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name='telephone' label="Téléphone" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name='adresse' label="Adresse">
          <Input.TextArea />
        </Form.Item>

      </Form>
    </Modal>
  );
};

export default CollectionCreateForm;